@import 'styles/variables';
@import 'styles/mixins';

.warning {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  max-width: 600px;
  width: 90%;
  background: $gold-20;
  border: 2px solid $gold-50;
  border-radius: 8px;
  @include shadow-3;
}

.content {
  padding: 20px;
  color: $gold-70;

  strong {
    display: block;
    margin-bottom: 12px;
    font-size: 16px;
    color: $gold-70;
  }

  p {
    margin: 12px 0;
    line-height: 1.5;
    font-size: 14px;

    code {
      background: var(--dark-10);
      padding: 2px 6px;
      border-radius: 3px;
      font-family: monospace;
      font-size: 13px;
    }
  }
}

.dismiss {
  margin-top: 16px;
  padding: 8px 16px;
  background: $gold-50;
  color: $gold-70;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;

  &:hover {
    background: $gold-40;
  }
}
